"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSimpleFilter = void 0;
function createSimpleFilter(filter) {
    const fieldId = Object.keys(filter)[0];
    const comparator = Object.keys(filter[fieldId])[0];
    return Object.freeze({
        fieldId: fieldId,
        comparator: comparator,
        comparedValue: filter[fieldId][comparator]
    });
}
exports.createSimpleFilter = createSimpleFilter;
